import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-table-no-data',
  standalone: true,
  imports: [
    MatIconModule, MatButtonModule, CommonModule
  ],
  templateUrl: './table-no-data.component.html',
  styleUrl: './table-no-data.component.scss'
})
export class TableNoDataComponent {
  showButton = false;
  buttonText: string = '';
  buttonRoute: string = '';
  @Input() isLoading: boolean;
  @Input() isSelectClientPage: boolean = false;
  constructor(private router: Router) { }

  ngOnInit(): void {
    const currentUrl = this.router.url;
    const clientPrefix = currentUrl.match(/^\/client\/\d+/)?.[0] ?? '';

    switch (true) {
      case currentUrl.endsWith('/users'):
        this.buttonText = 'Add New User';
        this.buttonRoute = `${currentUrl}/create`;
        this.showButton = true;
        break;

      case currentUrl.endsWith('/user-class'):
        this.buttonText = 'Add User Class';
        this.buttonRoute = `${currentUrl}/create`;
        this.showButton = true;
        break;

      case currentUrl.endsWith('/fdid/sessions'):
      case currentUrl.endsWith('/fdid/fdid-warnings'):
        this.buttonText = 'Click here and check if FD.ID is enabled';
        this.buttonRoute = `${clientPrefix}/onboarding/fdid-onboarding`;
        this.showButton = true;
        break;

      default:
        this.showButton = false;
    }

  }


  redirectTo(): void {
    this.router.navigate([this.buttonRoute]);
  }
}


